import React from 'react';
import styles from './index.module.scss';

export default function Footer() {
  return (
    <div className={styles.footer}>
      {/* <div className={styles.links}>
        <a href="#" className={styles.link}>
          帮助
        </a>
        <a href="#" className={styles.link}>
          隐私
        </a>
        <a href="#" style={{ marginRight: '0' }} className={styles.link}>
          条款
        </a>
      </div> */}
      <div className={styles.copyright}>©2023 百分之一软件 备案号：<a href="http://www.beian.miit.gov.cn/" style={{color:"#fff"}}>苏ICP备18027515号</a></div>
    </div>
  );
}
